
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ChallengesSection from './components/ChallengesSection';
import SolutionsSection from './components/SolutionsSection';
import SpecializationSection from './components/SpecializationSection';
import RoleSection from './components/RoleSection';
import OutsourcingSection from './components/OutsourcingSection';
import ContactFormSection from './components/ContactFormSection';

const SafetyStaffingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Safety Staffing Solutions - HP Inc Consulting Services | On-Site Safety Personnel"
        description="Professional safety staffing solutions providing qualified safety managers, coordinators, and specialists for construction and industrial projects. Expert on-site safety personnel across the Northeast."
        keywords="safety staffing, safety personnel, on-site safety manager, safety coordinator, construction safety staffing, industrial safety staffing, temporary safety staff, safety specialist, project safety management"
        canonical="https://hpincconsultant.com/safety-staffing"
        ogTitle="Safety Staffing Solutions - Professional On-Site Safety Personnel"
        ogDescription="Expert safety staffing solutions providing qualified safety managers and coordinators for construction and industrial projects."
        ogUrl="https://hpincconsultant.com/safety-staffing"
      />
      <Header />
      <HeroSection />
      <IntroSection />
      <ChallengesSection />
      <SolutionsSection />
      <SpecializationSection />
      <RoleSection />
      <OutsourcingSection />
      <ContactFormSection />
    </div>
  );
};

export default SafetyStaffingPage;
